export default "__VITE_ASSET__2faf5031__"